import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "publication-filters" }
const _hoisted_2 = ["title"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "treebal-arrow-down" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "dropdown-menu dropdown-menu-sort" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["dropdown", { active: _ctx.currentSort !== _ctx.defaultSort }])
    }, [
      _createElementVNode("button", {
        ref: "toggle",
        class: "btn btn-neutral btn-sort",
        type: "button",
        "data-bs-toggle": "dropdown",
        "aria-expanded": "false",
        title: _ctx.$t('organization.members.sorts.title')
      }, _hoisted_4, 8, _hoisted_2),
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableSorts, (s) => {
          return (_openBlock(), _createElementBlock("li", {
            key: s.value
          }, [
            _createElementVNode("button", {
              class: _normalizeClass(["dropdown-item", { active: _ctx.currentSort === s.value }]),
              onClick: ($event: any) => (_ctx.changeSort(s.value))
            }, _toDisplayString(s.label), 11, _hoisted_6)
          ]))
        }), 128))
      ])
    ], 2)
  ]))
}